import { makeRequest } from './data_utils';

const loadUserDashboards = () => {
  return makeRequest('dashboards/', 'GET');
};

const loadDashboard = (id) => {
    const endpoint = `dashboards/${id}/`;
    return makeRequest(endpoint, 'GET');
};

export const dataDashboards = {
    loadUserDashboards,
    loadDashboard
};